import styled, { css } from 'styled-components';
import { theme } from "../themes";

const Styles = css`
  .text-center {
    text-align: center;
  }

  .hidden {
    display: none;
  }
`

export default Styles
